export default __webpack_public_path__ + "832af60f34c09efa226c0ff77744f4c1.png";